import React, { useEffect, useState } from "react";
import FailedModal from "../../../CustomModal/Failed";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import useLatLng from "../../../../hooks/uselatlng/uselatlng";
import { toast } from "react-toastify";
import SuccessModal from "../../../CustomModal/Success";

const SiteVisit = ({
  history,
  match,
  allCity,
  allCityDetails = [],
  saveSiteVisit,
  siteVisit = [],
  valetOperationProject,
  projectById = [],
  getExistingSites,
  existingSiteDetails = []
}) => {
  var now = new Date();
  now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
  const islatlng = useLatLng();
  const [isLoading, setIsLoading] = useState(false);
  const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
  const [countToOpenModal, setCountToOpenModal] = useState(0);
  const [inputList, setInputList] = useState([
    {
      site_name: "",
      meta_data: {
        Site_Visit_Checklist: [{}],
        User_Ground_Experience: [{}],
        Valet_Manpower_Alignment: [{}],
        Customer_Product_Experience: [{}],
        User_Adoption_Decreased: [{}],
        User_Adoption_Increased: [{}],
        Client_Alignment: [{}],
        relationship_meeting_details: [{}],
        payment_collection_details: [{}],
      },
      poc_details: {},
      spoc_details: {},
      lat: "",
      long: "",
    },
  ]);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
  const [interactWithUser, setInteractWithUser] = useState("");
  const [managementBySupervisor, setManagementBySupervisor] = useState("");
  const [faceByManpower, setFaceByManpower] = useState("");
  const [friendlinessWithSolution, setFriendlinessWithSolution] = useState("");
  const [userOnGround, setUserOnGround] = useState("");
  const [reachValetDesk, setReachValetDesk] = useState("");
  const [payGetMyCar, setPayGetMyCar] = useState("");
  const [userRatingTips, setUserRatingTips] = useState("");
  const [selectedMeetingType, setSelectedMeetingType] = useState("");

  const handleMeetingTypeChange = (e) => {
    setSelectedMeetingType(e.target.value);
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await allCity();
      await valetOperationProject(match?.params?.id);
      setIsLoading(false);
    })();
  }, []);

  const handleInput = (key, val, metaKey, e, section) => {
    if (key === "meta_data") {
      if (e.target !== undefined && e.target.selectedOptions !== undefined) {
        inputList[0][key][section][0][metaKey] =
          e.target.selectedOptions[0].text;
      } else {
        inputList[0][key][section][0][metaKey] = val;
      }
    } else {
      inputList[0][key] = val;
    }
    setInputList(inputList);
  };

  const handlePOCInput = (key, val, metaKey, e) => {
    let list = [...inputList];
     if(key === "poc_details"){
      if (e.target !== undefined && e.target.selectedOptions !== undefined) {
        let desc = e.target.selectedOptions[0].text;
        inputList[0][key][metaKey] = desc;
        inputList[0][key][metaKey + "_id"] = val;
      } else {
        inputList[0][key][metaKey] = val;
      }
    } else if(key === "spoc_details"){
      if (e.target !== undefined && e.target.selectedOptions !== undefined) {
        let desc = e.target.selectedOptions[0].text;
        inputList[0][key][metaKey] = desc;
        inputList[0][key][metaKey + "_id"] = val;
      } else {
        inputList[0][key][metaKey] = val;
      }
    }else {
      inputList[0][key] = val;
    }
    setInputList(list);
  };

  const toRad = (Value) => {
    return (Value * Math.PI) / 180;
  };

  const calcCrow = (lat1, lon1, lat2, lon2) => {
    var R = 6371; // km
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var lat1 = toRad(lat1);
    var lat2 = toRad(lat2);

    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
  };

  useEffect(() => {
    setIsFailedModalOpen(false);
    setIsSuccessModalOpen(false);
    if (parseInt(siteVisit?.status) === 200) {
      setIsSuccessModalOpen(true);
      // window.location.href = `dealer-activity-list/${match?.params?.module_id}`
    } else if (
      siteVisit?.status !== undefined &&
      parseInt(siteVisit?.status) !== 200
    ) {
      setCountToOpenModal(countToOpenModal + 1);
      setIsFailedModalOpen(true);
    }
  }, [siteVisit]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getExistingSites("", "", match?.params?.id);
      setIsLoading(false);
    })();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let list = inputList[0];
    list["valet_project_id"] = match?.params?.id;
    list["lat"] = islatlng?.lat;
    list["long"] = islatlng?.lng;
    list['site_name'] =  existingSiteDetails?.data?.resultSets[0]?.project_name;
    list['next_activity_type_id'] = 47;
    list['meta_data']['Site_Visit_Checklist'][0]['city'] = existingSiteDetails?.data?.resultSets[0]?.city;
    list['meta_data']['meeting_type'] = selectedMeetingType;
    list['meta_data']['Site_Visit_Checklist'][0]['site_name'] = existingSiteDetails?.data?.resultSets[0]?.project_name;
    if (list["long"] == null || list["lat"] == null) {
      toast.error("Please enable your location");
      return false;
    }
    console.log("Testhdgfvgfd:",list?.meta_data?.Client_Alignment[0]?.Client_Mom )
    if (list?.meta_data?.Client_Alignment[0]?.Client_Mom!== undefined && list?.meta_data?.Client_Alignment[0]?.Client_Mom.split(" ").length < 30) {
      toast.warning("MOM must be minimum 25-30 words")
      return false
    }
    if (list?.meta_data?.payment_collection_details[0]?.payment_collection_mom!== undefined && list?.meta_data?.payment_collection_details[0]?.payment_collection_mom.split(" ").length < 30) {
      toast.warning("MOM must be minimum 25-30 words")
      return false
    }
    if (list?.meta_data?.relationship_meeting_details[0]?.relationship_meeting_mom!== undefined && list?.meta_data?.relationship_meeting_details[0]?.relationship_meeting_mom.split(" ").length < 30) {
      toast.warning("MOM must be minimum 25-30 words")
      return false
    }
    setIsLoading(true);
    await saveSiteVisit(list);
    setIsLoading(false);
  };

  useEffect(() => {
    if (projectById?.latitude !== undefined) {
      let distance = calcCrow(
        projectById?.latitude,
        projectById?.longitude,
        islatlng?.lat,
        islatlng?.lng
      );

      distance = parseFloat(distance).toFixed(2);
      console.log(distance);
      if (distance > 500) {
        toast.warning("Your are outside 500 m radius of valet site");
        setTimeout(() => {
          // window.location.href = `site-visit-list/${match?.params?.id}`;
        }, 1000);
      }
    }
  }, [projectById, islatlng?.lat]);

  return (
    <>
      <SuccessModal
        isOpen={isSuccessModalOpen}
        msg={siteVisit?.message}
        url={`valet-existing-sites`}
      />

      <FailedModal
        isOpen={isFailedModalOpen}
        msg={siteVisit?.message}
        countToOpenModal={countToOpenModal}
      />
      <Loader isLoading={isLoading} />

      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"Activity"} history={history} />
            {/*BODY*/}

            <div className="container-fluid common-bg">
              <>
                <div className="col-md-12">
                  <div>
                    <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                      <h1 className="h3 mb-0 text-black-100">Meeting Type</h1>
                    </div>
                    <div className="card-body bg-white">
                      <div className="user">
                        <div className="form-group row">
                          <div className="col-sm-6 mtk-075 d-mtk-03 float-field">
                            <select
                              className="form-control form-control-user"
                              onChange={handleMeetingTypeChange}
                              value={selectedMeetingType}
                            >
                              <option value="">Select Meeting Type</option>
                              <option value="inspection">Inspection</option>
                              <option value="relationship">
                                Relationship Meeting
                              </option>
                              <option value="payment">
                                Payment Collection
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <form onSubmit={(e) => handleSubmit(e)}>
                  {/* inspection form starts */}
                  {selectedMeetingType === "inspection" && (
                    <div className="row">
                      <div className="col-md-12">
                        <>
                          <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                            <h1 className="h3 mb-0 text-black-100">
                              Inspection
                            </h1>
                          </div>
                          <div className="card-body bg-white">
                            <div className="user">
                              <div className="form-group row">
                                <div className="col-sm-6 mtk-075 d-mtk-03 float-field">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    placeholder=" "
                                    value={existingSiteDetails?.data?.resultSets[0]?.project_name}
                                    disabled
                                    onChange={(e) => {
                                      handleInput(
                                        "site_name",
                                        existingSiteDetails?.data?.resultSets[0]?.project_name,
                                        e
                                      );
                                      handleInput(
                                        "meta_data",
                                        existingSiteDetails?.data?.resultSets[0]?.project_name,
                                        "Site_Name",
                                        e,
                                        "Site_Visit_Checklist"
                                      );
                                    }}
                                    id="validationCustom01"
                                    required
                                  />
                                  <label className="large-label float-lb">
                                    Site Name{" "}
                                    <i className="bi bi-asterisk astrick-icon"></i>
                                  </label>
                                </div>
                                <div className="col-sm-6 mtk-1 d-mtk-2 float-field">
                                  <select
                                    className="form-control form-control-user"
                                    onChange={(e) => {
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "Site_Type",
                                        e,
                                        "Site_Visit_Checklist"
                                      );
                                    }}
                                    required
                                  >
                                    <option value="">
                                      Select Type of site
                                    </option>
                                    <option value="Manpower + SaaS">
                                      Manpower + SaaS
                                    </option>
                                    <option value="Only SaaS">Only SaaS</option>
                                  </select>
                                  <label className="large-label float-lb">
                                    Type of site{" "}
                                    <i className="bi bi-asterisk astrick-icon"></i>
                                  </label>
                                </div>
                                <div className="col-sm-6 mtk-1 d-mtk-2 float-field">
                                  <select
                                    className="form-control form-control-user"
                                    value={existingSiteDetails?.data?.resultSets[0]?.city}
                                    disabled
                                    onChange={(e) => {
                                      handleInput(
                                        "meta_data",
                                        existingSiteDetails?.data?.resultSets[0]?.city,
                                        "City_Name",
                                        e,
                                        "Site_Visit_Checklist"
                                      );
                                      handleInput("city_id", e.target.value, e);
                                    }}
                                    required
                                  >
                                    <option value="">Select City</option>
                                    {allCityDetails.map((val, i) => {
                                      return (
                                        <>
                                          <option value={existingSiteDetails?.data?.resultSets[0]?.city}>
                                            {existingSiteDetails?.data?.resultSets[0]?.city}
                                          </option>
                                        </>
                                      );
                                    })}
                                  </select>
                                  <label className="large-label float-lb">
                                    City{" "}
                                    <i className="bi bi-asterisk astrick-icon"></i>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                      <div className="col-md-12">
                        <>
                          <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                            <h1 className="h3 mb-0 text-black-100">
                              User Ground Experience
                            </h1>
                          </div>
                          <div className="card-body bg-white">
                            <div className="user">
                              <div className="form-group row">
                                <div className="col-sm-6 mtk-075 float-field">
                                  <textarea
                                    className="form-control form-control-user"
                                    placeholder="How was your manpower performing?"
                                    onChange={(e) => {
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "How_Was_Your_Manpower_Performing",
                                        e,
                                        "User_Ground_Experience"
                                      );
                                    }}
                                    id="validationCustom01"
                                    rows="4"
                                    cols="50"
                                    required={true}
                                  />
                                  <label className="large-label float-lb">
                                    {/*Description*/}
                                  </label>
                                </div>
                                <div className="col-sm-6 mtk-1 d-mtk-2 float-field">
                                  <select
                                    className="form-control form-control-user"
                                    onChange={(e) => {
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "How_Would_You_Rate_Your_Valet_Presentation",
                                        e,
                                        "User_Ground_Experience"
                                      );
                                    }}
                                    required
                                  >
                                    <option value="">Select Rate</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                  </select>
                                  <label className="large-label float-lb">
                                    How would you rate your valet presentation?{" "}
                                    <i className="bi bi-asterisk astrick-icon"></i>
                                  </label>
                                </div>
                                <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4 lg-dropdown-align">
                                  <select
                                    className="form-control form-control-user"
                                    onChange={(e) => {
                                      setInteractWithUser(e.target.value);
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "Was_the_Supervisor_Valet_Partner_interacting_well_with_users",
                                        e,
                                        "User_Ground_Experience"
                                      );
                                    }}
                                    required
                                  >
                                    <option value="">Select</option>
                                    <option value="YES, Interacting with every user possible and pitching on GMC and Online">
                                      YES, Interacting with every user possible
                                      and pitching on GMC and Online
                                    </option>
                                    <option value="YES, with selective users who asked">
                                      YES, with selective users who asked
                                    </option>
                                    <option value="NO, Did not interact actively">
                                      NO, Did not interact actively
                                    </option>
                                    <option value="Only interacted when the users enquired">
                                      Only interacted when the users enquired
                                    </option>
                                    <option value="Other">Other</option>
                                  </select>
                                  <label className="large-label float-lb">
                                    Was the Supervisor/ Valet Partner
                                    interacting well with users?{" "}
                                    <i className="bi bi-asterisk astrick-icon"></i>
                                  </label>
                                </div>
                                {interactWithUser === "Other" && (
                                  <div className="col-sm-6 mtk-075 float-field">
                                    <input
                                      type="text"
                                      className="form-control form-control-user"
                                      placeholder=" "
                                      onChange={(e) => {
                                        handleInput(
                                          "meta_data",
                                          e.target.value,
                                          "Was_the_Supervisor_Valet_Partner_interacting_well_with_users_other",
                                          e,
                                          "User_Ground_Experience"
                                        );
                                      }}
                                      id="validationCustom01"
                                      required={true}
                                    />
                                    <label className="large-label float-lb">
                                      Other
                                    </label>
                                  </div>
                                )}
                                <div className="col-sm-6 mtk-1 d-mtk-2 float-field">
                                  <select
                                    className="form-control form-control-user"
                                    onChange={(e) => {
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "Did_you_observe_an_absolute_rating_tips",
                                        e,
                                        "User_Ground_Experience"
                                      );
                                    }}
                                  >
                                    <option value="">Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="Missed for few cases - occupied in ground challenge">
                                      Missed for few cases - occupied in ground
                                      challenge
                                    </option>
                                    <option value="Missed for few cases - hesitant or not regular">
                                      Missed for few cases - hesitant or not
                                      regular
                                    </option>
                                    <option value="Missed in most cases">
                                      Missed in most cases
                                    </option>
                                  </select>
                                  <label className="large-label float-lb">
                                    Did you observe an absolute rating & tips?
                                  </label>
                                </div>
                                <div className="col-sm-6 mtk-075 float-field">
                                  <textarea
                                    className="form-control form-control-user"
                                    placeholder="Name of Valet Partner(s) who still have scope of improvement in talking to users and Presentation/Grooming."
                                    onChange={(e) => {
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "Name_of_Valet_Partner_who_still_have_scope_of_improvement",
                                        e,
                                        "User_Ground_Experience"
                                      );
                                    }}
                                    id="validationCustom01"
                                    rows="4"
                                    cols="20"
                                    required={true}
                                  />
                                  <label className="large-label float-lb">
                                    {/*Description*/}
                                  </label>
                                </div>
                                <div className="col-sm-6 mtk-075 float-field">
                                  <textarea
                                    className="form-control form-control-user"
                                    placeholder="Name of Valet Partner(s) who were facing difficulties with Product and Need Training."
                                    onChange={(e) => {
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "partner_facing_difficulties_product_and_need_training",
                                        e,
                                        "User_Ground_Experience"
                                      );
                                    }}
                                    id="validationCustom01"
                                    rows="4"
                                    cols="20"
                                    required={true}
                                  />
                                </div>
                                <div className="col-sm-6 mtk-075 float-field">
                                  <textarea
                                    className="form-control form-control-user"
                                    placeholder="Name of Valet Partner(s) put on warning/off-boarded."
                                    onChange={(e) => {
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "partner_put_on_warning_off_boarded",
                                        e,
                                        "User_Ground_Experience"
                                      );
                                    }}
                                    id="validationCustom01"
                                    rows="4"
                                    cols="20"
                                    required={true}
                                  />
                                </div>
                                <div className="col-sm-6 mtk-1 d-mtk-2 float-field lg-dropdown-align">
                                  <select
                                    className="form-control form-control-user"
                                    onChange={(e) => {
                                      setManagementBySupervisor(e.target.value);
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "Insights_on_Key_Management_by_Supervisor",
                                        e,
                                        "User_Ground_Experience"
                                      );
                                    }}
                                    required
                                  >
                                    <option value="">Select</option>
                                    <option value="Key Handover is an Issue with major confusion during peak hours observed">
                                      Key Handover is an Issue with major
                                      confusion during peak hours observed
                                    </option>
                                    <option value="Key Handover done efficiently by Supervisor with Tag system">
                                      Key Handover done efficiently by
                                      Supervisor with Tag system
                                    </option>
                                    <option value="Key Management by Valet Supervisor needs major training">
                                      Key Management by Valet Supervisor needs
                                      major training
                                    </option>
                                    <option value="Other">Other</option>
                                  </select>
                                  <label className="large-label float-lb">
                                    Insights on Key Management by Supervisor
                                    (Any challenges observed?){" "}
                                    <i className="bi bi-asterisk astrick-icon"></i>
                                  </label>
                                </div>
                                {managementBySupervisor === "Other" && (
                                  <div className="col-sm-6 mtk-075 float-field">
                                    <input
                                      type="text"
                                      className="form-control form-control-user"
                                      placeholder=" "
                                      onChange={(e) => {
                                        handleInput(
                                          "meta_data",
                                          e.target.value,
                                          "Insights_on_key_management_by_supervisor_other",
                                          e,
                                          "User_Ground_Experience"
                                        );
                                      }}
                                      id="validationCustom01"
                                      required={true}
                                    />
                                    <label className="large-label float-lb">
                                      Other
                                    </label>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                      <div className="col-md-12">
                        <>
                          <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                            <h1 className="h3 mb-0 text-black-100">
                              Valet Manpower Alignment
                            </h1>
                          </div>
                          <div className="card-body bg-white">
                            <div className="user">
                              <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4 lg-dropdown-align">
                                <select
                                  className="form-control form-control-user"
                                  onChange={(e) => {
                                    handleInput(
                                      "meta_data",
                                      e.target.value,
                                      "manpower_onboarding_formalities_background_verification_done",
                                      e,
                                      "Valet_Manpower_Alignment"
                                    );
                                  }}
                                  required
                                >
                                  <option value="">Select</option>
                                  <option value="Yes">Yes</option>
                                  <option value="No">No</option>
                                  <option value="A few Left with less than 3 days since deployment">
                                    A few Left with less than 3 days since
                                    deployment
                                  </option>
                                  <option value="A few left wit more than 5 days since deployment">
                                    A few left wit more than 5 days since
                                    deployment
                                  </option>
                                </select>
                                <label className="large-label float-lb">
                                  Are all manpower completed with onboarding
                                  formalities and Background verification
                                  cleared?{" "}
                                  <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                              <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4">
                                <select
                                  className="form-control form-control-user"
                                  onChange={(e) => {
                                    setFaceByManpower(e.target.value);
                                    handleInput(
                                      "meta_data",
                                      e.target.value,
                                      "Any_major_concerns_faced_by_manpower",
                                      e,
                                      "Valet_Manpower_Alignment"
                                    );
                                  }}
                                  required
                                >
                                  <option value="">Select</option>
                                  <option value="Incentive and Payout">
                                    Incentive and Payout
                                  </option>
                                  <option value="Site Level Altercations with Users">
                                    Site Level Altercations with Users
                                  </option>
                                  <option value="Client Level challenges in Communication">
                                    Client Level challenges in Communication
                                  </option>
                                  <option value="Absence of apt resources on site">
                                    Absence of apt resources on site
                                  </option>
                                  <option value="Other">Other</option>
                                </select>
                                <label className="large-label float-lb">
                                  Any major concerns faced by Manpower?{" "}
                                  <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>

                              {faceByManpower === "Other" && (
                                <div className="col-sm-6 mtk-075 float-field mb-4">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    placeholder=" "
                                    onChange={(e) => {
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "Any_major_concerns_faced_by_manpower_other",
                                        e,
                                        "Valet_Manpower_Alignment"
                                      );
                                    }}
                                    id="validationCustom01"
                                    required={true}
                                  />
                                  <label className="large-label float-lb">
                                    Other
                                  </label>
                                </div>
                              )}
                              <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4">
                                <select
                                  className="form-control form-control-user"
                                  onChange={(e) => {
                                    handleInput(
                                      "meta_data",
                                      e.target.value,
                                      "All_manpower_clear_on_incentive_policy",
                                      e,
                                      "Valet_Manpower_Alignment"
                                    );
                                  }}
                                >
                                  <option value="">Select</option>
                                  <option value="Yes">Yes</option>
                                  <option value="No">No</option>
                                </select>
                                <label className="large-label float-lb">
                                  All manpower clear on incentive policy?
                                </label>
                              </div>
                              <div className="col-sm-6 mtk-075 float-field mb-4">
                                <textarea
                                  className="form-control form-control-user"
                                  placeholder="Name of Valet - Not Clear with site SOPs - namely

                                                                    a) Site Reporting Time/Roster
                                                                    b) Escalation Matrix
                                                                    c) TagTransfer SOP"
                                  onChange={(e) => {
                                    handleInput(
                                      "meta_data",
                                      e.target.value,
                                      "Name_of_valet_Not_clear_with_site_SOPs_namely",
                                      e,
                                      "Valet_Manpower_Alignment"
                                    );
                                  }}
                                  id="validationCustom01"
                                  rows="4"
                                  cols="20"
                                  required={true}
                                />
                              </div>
                              <div className="col-sm-6 mtk-075 float-field mb-4">
                                <textarea
                                  className="form-control form-control-user"
                                  placeholder="Any Retraining done?"
                                  onChange={(e) => {
                                    handleInput(
                                      "meta_data",
                                      e.target.value,
                                      "Any_retraining_done",
                                      e,
                                      "Valet_Manpower_Alignment"
                                    );
                                  }}
                                  id="validationCustom01"
                                  rows="4"
                                  cols="20"
                                  required={true}
                                />
                              </div>
                              <div className="col-sm-6 mtk-075 float-field mb-4">
                                <textarea
                                  className="form-control form-control-user"
                                  placeholder="Any other observation."
                                  onChange={(e) => {
                                    handleInput(
                                      "meta_data",
                                      e.target.value,
                                      "Any_other_observation",
                                      e,
                                      "Valet_Manpower_Alignment"
                                    );
                                  }}
                                  id="validationCustom01"
                                  rows="4"
                                  cols="20"
                                  required={true}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                      <div className="col-md-12">
                        <>
                          <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                            <h1 className="h3 mb-0 text-black-100">
                              Customer Product Experience
                            </h1>
                          </div>
                          <div className="card-body bg-white">
                            <div className="user">
                              <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4 lg-dropdown-align">
                                <select
                                  className="form-control form-control-user"
                                  onChange={(e) => {
                                    handleInput(
                                      "meta_data",
                                      e.target.value,
                                      "Rate_overall_product_experience_for_user_observed_basis",
                                      e,
                                      "Customer_Product_Experience"
                                    );
                                  }}
                                  required
                                >
                                  <option value="">Select</option>
                                  <option value="1">1</option>
                                  <option value="2">2</option>
                                  <option value="3">3</option>
                                  <option value="4">4</option>
                                  <option value="5">5</option>
                                </select>
                                <label className="large-label float-lb">
                                  Rate overall product experience for user
                                  observed basis{" "}
                                  <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                              <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4">
                                <select
                                  className="form-control form-control-user"
                                  onChange={(e) => {
                                    setFriendlinessWithSolution(e.target.value);
                                    handleInput(
                                      "meta_data",
                                      e.target.value,
                                      "Customer_friendliness_with_overall_solution",
                                      e,
                                      "Customer_Product_Experience"
                                    );
                                  }}
                                  required
                                >
                                  <option value="">Select</option>
                                  <option value="Has Improved since last visit">
                                    Has Improved since last visit
                                  </option>
                                  <option value="Is the same since last visit">
                                    Is the same since last visit
                                  </option>
                                  <option value="Has Gone Down since Last Visit">
                                    Has Gone Down since Last Visit
                                  </option>
                                  <option value="Needs Major Improvement">
                                    Needs Major Improvement
                                  </option>
                                </select>
                                <label className="large-label float-lb">
                                  Customer Friendliness with overall solution?{" "}
                                  <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                      {(friendlinessWithSolution ===
                        "Has Gone Down since Last Visit" ||
                        friendlinessWithSolution ===
                          "Needs Major Improvement") && (
                        <div className="col-md-12">
                          <>
                            <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                              <h1 className="h3 mb-0 text-black-100">
                                User Adoption Decreased
                              </h1>
                            </div>
                            <div className="card-body bg-white">
                              <div className="user">
                                <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4">
                                  <select
                                    className="form-control form-control-user"
                                    onChange={(e) => {
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "Is_the_GMC_pitch_done_aggressively_by_Valet",
                                        e,
                                        "User_Adoption_Decreased"
                                      );
                                    }}
                                    required
                                  >
                                    <option value="">Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                    <option value="Done But Not Aggressive">
                                      Done But Not Aggressive
                                    </option>
                                  </select>
                                  <label className="large-label float-lb">
                                    Is the GMC pitch done aggressively by Valet?{" "}
                                    <i className="bi bi-asterisk astrick-icon"></i>
                                  </label>
                                </div>
                                <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4">
                                  <select
                                    className="form-control form-control-user"
                                    onChange={(e) => {
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "Challenge_observed_in_application_download",
                                        e,
                                        "User_Adoption_Decreased"
                                      );
                                    }}
                                    required
                                  >
                                    <option value="">Select</option>
                                    <option value="Network Connectivity on Porch">
                                      Network Connectivity on Porch
                                    </option>
                                    <option value="Supervisor not Making services clear">
                                      Supervisor not Making services clear
                                    </option>
                                    <option value="Denied by Users Post hearing Pitch">
                                      Denied by Users Post hearing Pitch
                                    </option>
                                    <option value="NA">NA</option>
                                  </select>
                                  <label className="large-label float-lb">
                                    Challenge observed in application download{" "}
                                    <i className="bi bi-asterisk astrick-icon"></i>
                                  </label>
                                </div>
                                <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4 lg-dropdown-align">
                                  <select
                                    className="form-control form-control-user"
                                    onChange={(e) => {
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "If_payment_enabled_what_is_the_challenge_with_online_payment_usage",
                                        e,
                                        "User_Adoption_Decreased"
                                      );
                                    }}
                                    required
                                  >
                                    <option value="">Select</option>
                                    <option value="Network Issue">
                                      Network Issue
                                    </option>
                                    <option value="UPI platform level Issue">
                                      UPI platform level Issue
                                    </option>
                                    <option value="NO UPI platform present">
                                      NO UPI platform present
                                    </option>
                                    <option value="Prefers cash over online">
                                      Prefers cash over online
                                    </option>
                                    <option value="Did Pay and Get Car but Drop Request Not created">
                                      Did Pay and Get Car but Drop Request Not
                                      created
                                    </option>
                                    <option value="Manpower Not Pitching Online Payment and readily accepting cash">
                                      Manpower Not Pitching Online Payment and
                                      readily accepting cash
                                    </option>
                                    <option value="NA">NA</option>
                                  </select>
                                  <label className="large-label float-lb">
                                    If payment enabled, what is the challenge
                                    with online payment usage?
                                  </label>
                                </div>
                                <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4 lg-dropdown-align">
                                  <select
                                    className="form-control form-control-user"
                                    onChange={(e) => {
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "If_payment_enabled_Were_users_receiving_alerts_on_payment_confirmation",
                                        e,
                                        "User_Adoption_Decreased"
                                      );
                                    }}
                                    required
                                  >
                                    <option value="">Select</option>
                                    <option value="Yes (timely)">
                                      Yes (timely)
                                    </option>
                                    <option value="Yes (Delayed by seconds)">
                                      Yes (Delayed by seconds)
                                    </option>
                                    <option value="Yes (Delayed by Minutes)">
                                      Yes (Delayed by Minutes)
                                    </option>
                                    <option value="Not Receiving">
                                      Not Receiving
                                    </option>
                                    <option value="NA">NA</option>
                                  </select>
                                  <label className="large-label float-lb">
                                    If payment enabled -Were users receiving
                                    alerts on payment confirmation?
                                  </label>
                                </div>
                                <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4">
                                  <select
                                    className="form-control form-control-user"
                                    onChange={(e) => {
                                      setUserRatingTips(e.target.value);
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "Issues_observed_with_respect_to_user_rating_tips",
                                        e,
                                        "User_Adoption_Decreased"
                                      );
                                    }}
                                    required
                                  >
                                    <option value="">Select</option>
                                    <option value="Rating & Tip Pitch Missed by Valet Partner">
                                      Rating & Tip Pitch Missed by Valet Partner
                                    </option>
                                    <option value="Users in Hurry and Not agreeing to fill rating">
                                      Users in Hurry and Not agreeing to fill
                                      rating
                                    </option>
                                    <option value="User Agreeing to Rate but Not doing so">
                                      User Agreeing to Rate but Not doing so
                                    </option>
                                    <option value="User Rating screen not loading/working on GMC page">
                                      User Rating screen not loading/working on
                                      GMC page
                                    </option>
                                    <option value="Other">Other</option>
                                  </select>
                                  <label className="large-label float-lb"></label>
                                  Issues observed with respect to User Rating &
                                  Tips
                                </div>
                                {userRatingTips === "Other" && (
                                  <div className="col-sm-6 mtk-075 float-field">
                                    <input
                                      type="text"
                                      className="form-control form-control-user"
                                      placeholder=" "
                                      onChange={(e) => {
                                        handleInput(
                                          "meta_data",
                                          e.target.value,
                                          "Issues_observed_with_respect_to_user_rating_tips_other",
                                          e,
                                          "User_Adoption_Decreased"
                                        );
                                      }}
                                      id="validationCustom01"
                                      required={true}
                                    />
                                    <label className="large-label float-lb">
                                      Other
                                    </label>
                                  </div>
                                )}
                                <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4">
                                  <select
                                    className="form-control form-control-user"
                                    onChange={(e) => {
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "Is_supervisor_regular_in_online_app_install_pitch",
                                        e,
                                        "User_Adoption_Decreased"
                                      );
                                    }}
                                    required
                                  >
                                    <option value="">Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                    <option value="Yes with a few Misses">
                                      Yes with a few Misses
                                    </option>
                                  </select>
                                  <label className="large-label float-lb">
                                    Is Supervisor regular in Online & App
                                    install pitch?
                                  </label>
                                </div>

                                <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4">
                                  <select
                                    className="form-control form-control-user"
                                    onChange={(e) => {
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "Number_of_users_you_interacted_with",
                                        e,
                                        "User_Adoption_Decreased"
                                      );
                                    }}
                                    required
                                  >
                                    <option value="">Select</option>
                                    <option value="0">0</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4 or more">4 or more</option>
                                  </select>
                                  <label className="large-label float-lb">
                                    Number of Users You interacted with
                                  </label>
                                </div>

                                <div className="col-sm-6 mtk-075 float-field mb-4">
                                  <textarea
                                    className="form-control form-control-user"
                                    placeholder="Any feedback shared by the user on solution used? Please quote any 2 users."
                                    onChange={(e) => {
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "Any_feedback_shared_by_the_user_on_solution_used_please_quote_any_2_users",
                                        e,
                                        "User_Adoption_Decreased"
                                      );
                                    }}
                                    id="validationCustom01"
                                    rows="4"
                                    cols="20"
                                    required={true}
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        </div>
                      )}

                      {(friendlinessWithSolution ===
                        "Has Improved since last visit" ||
                        friendlinessWithSolution ===
                          "Is the same since last visit") && (
                        <div className="col-md-12">
                          <>
                            <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                              <h1 className="h3 mb-0 text-black-100">
                                User Adoption Increased
                              </h1>
                            </div>
                            <div className="card-body bg-white">
                              <div className="user">
                                <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4 lg-dropdown-align">
                                  <select
                                    className="form-control form-control-user"
                                    onChange={(e) => {
                                      setUserOnGround(e.target.value);
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "How_is_the_GMC_through_Park_application_awareness_amongst_users_on_ground",
                                        e,
                                        "User_Adoption_Increased"
                                      );
                                    }}
                                    required
                                  >
                                    <option value="">Select</option>
                                    <option value="Users aware and Doing Get My Car Organically">
                                      Users aware and Doing Get My Car
                                      Organically
                                    </option>
                                    <option value="Supervisor & Driver pitching GMC aggressively during pickup">
                                      Supervisor & Driver pitching GMC
                                      aggressively during pickup
                                    </option>
                                    <option value="Major Lags in GMC pitch by Supervisor & Driver">
                                      Major Lags in GMC pitch by Supervisor &
                                      Driver
                                    </option>
                                    <option value="Other">Other</option>
                                  </select>
                                  <label className="large-label float-lb">
                                    How is the GMC through Park+ application
                                    awareness amongst users on ground?{" "}
                                    <i className="bi bi-asterisk astrick-icon"></i>
                                  </label>
                                </div>
                                {userOnGround === "Other" && (
                                  <div className="col-sm-6 mtk-075 float-field mb-4">
                                    <input
                                      type="text"
                                      className="form-control form-control-user"
                                      placeholder=" "
                                      onChange={(e) => {
                                        handleInput(
                                          "meta_data",
                                          e.target.value,
                                          "How_is_the_GMC_through_Park_application_awareness_amongst_users_on_ground_other",
                                          e,
                                          "User_Adoption_Increased"
                                        );
                                      }}
                                      id="validationCustom01"
                                      required={true}
                                    />
                                    <label className="large-label float-lb">
                                      Other
                                    </label>
                                  </div>
                                )}
                                <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4 lg-dropdown-align">
                                  <select
                                    className="form-control form-control-user"
                                    onChange={(e) => {
                                      setReachValetDesk(e.target.value);
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "Have_the_users_started_using_Get_My_Car_before_reaching_valet_desk",
                                        e,
                                        "User_Adoption_Increased"
                                      );
                                    }}
                                    required
                                  >
                                    <option value="">Select</option>
                                    <option value="YES, Shift observed with Most Users preferring Pay and Get my Car before coming to Valet desk">
                                      YES, Shift observed with Most Users
                                      preferring Pay and Get my Car before
                                      coming to Valet desk
                                    </option>
                                    <option value="NO, Users still coming over to valet desk and doing Get My Car">
                                      NO, Users still coming over to valet desk
                                      and doing Get My Car
                                    </option>
                                    <option value="Other">Other</option>
                                  </select>
                                  <label className="large-label float-lb">
                                    Have the users started using 'Get My Car'
                                    before reaching valet desk?{" "}
                                    <i className="bi bi-asterisk astrick-icon"></i>
                                  </label>
                                </div>
                                {reachValetDesk === "Other" && (
                                  <div className="col-sm-6 mtk-075 float-field mb-4">
                                    <input
                                      type="text"
                                      className="form-control form-control-user"
                                      placeholder=" "
                                      onChange={(e) => {
                                        handleInput(
                                          "meta_data",
                                          e.target.value,
                                          "Have_the_users_started_using_Get_My_Car_before_reaching_valet_desk_other",
                                          e,
                                          "User_Adoption_Increased"
                                        );
                                      }}
                                      id="validationCustom01"
                                      required={true}
                                    />
                                    <label className="large-label float-lb">
                                      Other
                                    </label>
                                  </div>
                                )}
                                <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4 lg-dropdown-align">
                                  <select
                                    className="form-control form-control-user"
                                    onChange={(e) => {
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "If_payment_enabled_were_users_inclining_towards_online_payment",
                                        e,
                                        "User_Adoption_Increased"
                                      );
                                    }}
                                    required
                                  >
                                    <option value="">Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                    <option value="Not applicable">
                                      Not applicable
                                    </option>
                                  </select>
                                  <label className="large-label float-lb">
                                    If Payment enabled - were users inclining
                                    towards Online payment?
                                  </label>
                                </div>
                                <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4 lg-dropdown-align">
                                  <select
                                    className="form-control form-control-user"
                                    onChange={(e) => {
                                      setPayGetMyCar(e.target.value);
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "If_Payment_Enabled_for_online_payments_were_users_preferring_QR_scan_over_Pay_Get_my_car",
                                        e,
                                        "User_Adoption_Increased"
                                      );
                                    }}
                                  >
                                    <option value="">Select</option>
                                    <option value="Yes - Preferring Scan & Pay">
                                      Yes - Preferring Scan & Pay
                                    </option>
                                    <option value="No - doing Pay & Get my Car">
                                      No - doing Pay & Get my Car
                                    </option>
                                    <option value="Not applicable">
                                      Not applicable
                                    </option>
                                    <option value="Other">Other</option>
                                  </select>
                                  <label className="large-label float-lb">
                                    If Payment Enabled - for online payments,
                                    were users preferring QR scan over Pay & Get
                                    my car?
                                  </label>
                                </div>
                                {payGetMyCar === "Other" && (
                                  <div className="col-sm-6 mtk-075 float-field mb-4">
                                    <input
                                      type="text"
                                      className="form-control form-control-user"
                                      placeholder=" "
                                      onChange={(e) => {
                                        handleInput(
                                          "meta_data",
                                          e.target.value,
                                          "If_Payment_Enabled_for_online_payments_were_users_preferring_QR_scan_over_Pay_Get_my_car_other",
                                          e,
                                          "User_Adoption_Increased"
                                        );
                                      }}
                                      id="validationCustom01"
                                      required={true}
                                    />
                                    <label className="large-label float-lb">
                                      Other
                                    </label>
                                  </div>
                                )}
                                <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4">
                                  <select
                                    className="form-control form-control-user"
                                    onChange={(e) => {
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "Number_of_Users_You_interacted_with",
                                        e,
                                        "User_Adoption_Increased"
                                      );
                                    }}
                                    required
                                  >
                                    <option value="">Select</option>
                                    <option value="0">0</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4 or more">4 or more</option>
                                  </select>
                                  <label className="large-label float-lb">
                                    Number of Users You interacted with
                                  </label>
                                </div>

                                <div className="col-sm-6 mtk-075 float-field mb-4">
                                  <textarea
                                    className="form-control form-control-user"
                                    placeholder="Any feedback shared by the user on solution used? Please quote any 2 users."
                                    onChange={(e) => {
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "Any_feedback_shared_by_the_user_on_solution_used_Please_quote_any_users",
                                        e,
                                        "User_Adoption_Increased"
                                      );
                                    }}
                                    id="validationCustom01"
                                    rows="4"
                                    cols="20"
                                    required={true}
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        </div>
                      )}

                      <div className="col-md-12">
                        <>
                          <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                            <h1 className="h3 mb-0 text-black-100">
                              Client Alignment
                            </h1>
                          </div>
                          <div className="card-body bg-white">
                            <div className="user">
                              <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4">
                                <select
                                  className="form-control form-control-user"
                                  onChange={(e) => {
                                    setInputList((prevInputList) => {
                                      const updatedInputList = [
                                        ...prevInputList,
                                      ]; // Create a copy of inputList
                                      updatedInputList[0].meta_data.Client_Alignment[0].Did_you_meet_client_Site_Manager_or_Admin =
                                        e.target.value; // Update the value
                                      return updatedInputList; // Return the updated state
                                    });
                                  }}
                                  required
                                >
                                  <option value="">Select</option>
                                  <option value="Yes">Yes</option>
                                  <option value="No">No</option>
                                </select>
                                <label className="large-label float-lb">
                                  Did you meet client/Site Manager or Admin?{" "}
                                  <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                              {inputList[0]?.meta_data?.Client_Alignment[0]
                                ?.Did_you_meet_client_Site_Manager_or_Admin ===
                                "Yes" && (
                                <div className="col-sm-6 mtk-075 float-field mb-4">
                                  <textarea
                                    className="form-control form-control-user"
                                    placeholder="MOM (word limit of 25-30 words)"
                                    onChange={(e) => {
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "Client_Mom",
                                        e,
                                        "Client_Alignment"
                                      );
                                    }}
                                    id="validationCustom01"
                                    rows="4"
                                    cols="20"
                                    required={true}
                                  />
                                </div>
                              )}

                              <div className="col-sm-6 mtk-1 d-mtk-2 float-field ">
                                <select
                                  className="form-control form-control-user"
                                  onChange={(e) => {
                                    handleInput(
                                      "meta_data",
                                      e.target.value,
                                      "Meeting_MoM",
                                      e,
                                      "Client_Alignment"
                                    );
                                  }}
                                  required
                                >
                                  <option value="">Select</option>
                                  <option value="Shared with Client">
                                    Shared with Client
                                  </option>
                                  <option value="To be Shared">
                                    To be Shared
                                  </option>
                                  <option value="Did Not Meet Client">
                                    Did Not Meet Client
                                  </option>
                                </select>
                                <label className="large-label float-lb">
                                  Meeting MoM{" "}
                                  <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                      {inputList[0]?.meta_data?.Client_Alignment[0]
                        ?.Did_you_meet_client_Site_Manager_or_Admin ===
                        "Yes" && (
                        <div className="col-md-12">
                          <div>
                            <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                              <h1 className="h3 mb-0 text-black-100">
                                POC Details
                              </h1>
                            </div>
                            <div className="card-body bg-white">
                              <div className="user">
                                <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4">
                                  <input
                                    type="text"
                                    className="form-control form-control-user"
                                    placeholder=" "
                                    onChange={(e) => {
                                      handlePOCInput(
                                        "poc_details",
                                        e.target.value,
                                        "poc_name",
                                        e
                                      );
                                    }}
                                    id="validationCustom01"
                                    required
                                  />
                                  <label className="large-label float-lb">
                                    POC Name{" "}
                                    <i className="bi bi-asterisk astrick-icon"></i>
                                  </label>
                                </div>
                                <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4">
                                  <input
                                    type="email"
                                    className="form-control form-control-user"
                                    placeholder=" "
                                    onChange={(e) => {
                                      handlePOCInput(
                                        "poc_details",
                                        e.target.value,
                                        "poc_email",
                                        e
                                      );
                                    }}
                                    id="validationCustom01"
                                    required
                                  />
                                  <label className="large-label float-lb">
                                    POC Email{" "}
                                    <i className="bi bi-asterisk astrick-icon"></i>
                                  </label>
                                </div>
                                <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4">
                                  <input
                                    type="number"
                                    className="form-control form-control-user"
                                    placeholder=" "
                                    onChange={(e) => {
                                      let inputValue = e.target.value;
                                      inputValue = inputValue.replace(/\D/g, '');
                                      inputValue = inputValue.slice(0, 10);
                                      e.target.value = inputValue;
                                      handlePOCInput("poc_details", inputValue, "poc_number", e);
                                    }}
                                    id="validationCustom01"
                                    required
                                  />
                                  <label className="large-label float-lb">
                                    POC Mobile Number{" "}
                                    <i className="bi bi-asterisk astrick-icon"></i>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {/* inspection form ends */}

                  {/* relationship meeting starts */}
                  {selectedMeetingType === "relationship" && (
                    <div className="row">
                      <div className="col-md-12">
                        <div>
                          <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                            <h1 className="h3 mb-0 text-black-100">
                              Relationship Meeting
                            </h1>
                          </div>
                          <div className="card-body bg-white">
                            <div className="user">
                              <div className="form-group row">
                                <div className="col-md-12">
                                  <div>
                                    <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                      <h1 className="h3 mb-0 text-black-100">
                                        SPOC Details
                                      </h1>
                                    </div>
                                    <div className="card-body bg-white">
                                      <div className="user">
                                        <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4">
                                          <input
                                            type="text"
                                            className="form-control form-control-user"
                                            placeholder=" "
                                            onChange={(e) => {
                                              handlePOCInput(
                                                "spoc_details",
                                                e.target.value,
                                                "spoc_name",
                                                e
                                              );
                                            }}
                                            id="validationCustom01"
                                            required
                                          />
                                          <label className="large-label float-lb">
                                            SPOC Name{" "}
                                            <i className="bi bi-asterisk astrick-icon"></i>
                                          </label>
                                        </div>
                                        <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4">
                                          <input
                                            type="email"
                                            className="form-control form-control-user"
                                            placeholder=" "
                                            onChange={(e) => {
                                              handlePOCInput(
                                                "spoc_details",
                                                e.target.value,
                                                "spoc_email",
                                                e
                                              );
                                            }}
                                            id="validationCustom01"
                                            required
                                          />
                                          <label className="large-label float-lb">
                                            SPOC Email{" "}
                                            <i className="bi bi-asterisk astrick-icon"></i>
                                          </label>
                                        </div>
                                        <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4">
                                          <input
                                            type="number"
                                            className="form-control form-control-user"
                                            placeholder=" "
                                            onChange={(e) => {
                                              let inputValue = e.target.value;
                                              inputValue = inputValue.replace(/\D/g, '');
                                              inputValue = inputValue.slice(0, 10);
                                              e.target.value = inputValue;
                                              handlePOCInput("spoc_details", inputValue, "spoc_number", e);
                                            }}
                                            id="validationCustom01"
                                            required
                                          />
                                          <label className="large-label float-lb">
                                            SPOC Mobile Number{" "}
                                            <i className="bi bi-asterisk astrick-icon"></i>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4">
                                  <select
                                    className="form-control form-control-user"
                                    onChange={(e) => {
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "client_rating",
                                        e,
                                        "relationship_meeting_details"
                                      );
                                    }}
                                    required
                                  >
                                    <option value="">Select</option>
                                    <option value="0">0</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4 or more">4 or more</option>
                                  </select>
                                  <label className="large-label float-lb">
                                    Client Rating
                                  </label>
                                </div>
                                <div className="col-sm-6 mtk-075 float-field mb-4">
                                  <textarea
                                    className="form-control form-control-user"
                                    placeholder="MOM"
                                    onChange={(e) => {
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "relationship_meeting_mom",
                                        e,
                                        "relationship_meeting_details"
                                      );
                                    }}
                                    id="validationCustom01"
                                    rows="4"
                                    cols="20"
                                    required={true}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* relationship meeting end */}

                  {/* payment collection form starts */}
                  {selectedMeetingType === "payment" && (
                    <div className="row">
                      <div className="col-md-12">
                        <div>
                          <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                            <h1 className="h3 mb-0 text-black-100">
                              Payment Collection
                            </h1>
                          </div>
                          <div className="card-body bg-white">
                            <div className="user">
                              <div className="form-group row">
                                <div className="col-sm-6 mtk-1 d-mtk-2 float-field mb-4">
                                  <label className="large-label text-primary">
                                    Payment Expected Date
                                    <input
                                      type="date"
                                      className="form-control form-control-user"
                                      placeholder="Enter First Contact Date"
                                      onChange={(e) => {
                                        handleInput(
                                          "meta_data",
                                          e.target.value,
                                          "payment_collection_date",
                                          e,
                                          "payment_collection_details"
                                        );
                                      }}
                                    />
                                  </label>
                                </div>
                                <div className="col-sm-6 mtk-075 float-field mb-4">
                                  <textarea
                                    className="form-control form-control-user"
                                    placeholder="MOM"
                                    onChange={(e) => {
                                      handleInput(
                                        "meta_data",
                                        e.target.value,
                                        "payment_collection_mom",
                                        e,
                                        "payment_collection_details"
                                      );
                                    }}
                                    id="validationCustom01"
                                    rows="4"
                                    cols="20"
                                    required={true}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* payment collection form  ends */}
                  <div className="col-md-12 mt-4 d-flex">
                    <button className="btn btn-primary btn-user btn-block submit-btn">
                      Submit
                    </button>
                  </div>
                </form>
              </>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SiteVisit;
